import { Id, Invariant } from '@ess/jg-rule-executor';
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { InvariantInput, InvariantTranslationKey } from '@src/app/generated/globalTypes';
import {
  GetAllModuleBlueprints_allBlueprints_invariants,
  GetAllModuleBlueprints_allBlueprints_invariants_translationKeys,
  GetAllModuleBlueprints_allBlueprints_invariants_translations,
} from '@src/app/generated/GetAllModuleBlueprints';
import { ReverseJsonInputTranslatable } from '@src/app/model/reverse-json-input-translatable';

export class PortalInvariant extends Invariant implements ToJsonInputTranslatable, ReverseJsonInputTranslatable {
  translations: Map<InvariantTranslationKey, string>;

  constructor(
    id: Id<Invariant>,
    rule: string,
    translationKeys: Map<string, string>,
    translations: Map<InvariantTranslationKey, string>,
    correction?: string,
    name?: string,
    disableDuringOnChange?: boolean
  ) {
    super(id, rule, translationKeys, correction, name, disableDuringOnChange);
    this.translations = translations;
  }

  toGqlInput(): InvariantInput {
    return {
      name: this.name,
      id: this.id,
      correction: this.correction,
      rule: this.rule,
      translations: {
        values: Array.from(this.translations)
          .map(([k, v]) => ({ key: k, value: v })),
      },
      disableDuringOnChange: this.disableDuringOnChange,
    };
  }

  updateValuesFromGqlInput(gql: InvariantInput): PortalInvariant {
    return new PortalInvariant(
      this.id,
      gql.rule,
      new Map(), // Can be empty, generated by backend
      new Map(gql.translations.values.map(k => ([k.key, k.value]))),
      gql.correction,
      gql.name
    );
  }

  static fromGql(gql: GetAllModuleBlueprints_allBlueprints_invariants): PortalInvariant {
    return new PortalInvariant(
      gql.id,
      gql.rule,
      PortalInvariant.keysFromGql(gql.translationKeys),
      PortalInvariant.translationsFromGql(gql.translations),
      gql.correction,
      gql.name,
      gql.disableDuringOnChange
    );
  }

  static keysFromGql(gql: GetAllModuleBlueprints_allBlueprints_invariants_translationKeys[]): Map<string, string> {
    return new Map(gql.map(k => ([k.key, k.value])));
  }

  static translationsFromGql(
    gql: GetAllModuleBlueprints_allBlueprints_invariants_translations
  ): Map<InvariantTranslationKey, string> {
    return new Map(gql.values.map(k => ([k.key, k.value])));
  }
}
